import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const headerSx = {
    paddingBottom: '8px',
    paddingLeft: '0px',
    borderBottom: '1px solid #E5E9EC',
};

const cellSx = {
    borderBottom: '1px solid #E5E9EC',
    py: 2,
    paddingLeft: '0px',
};

const TableSkeleton = ({ columns }) => (
    <Box sx={{ marginBottom: '32px' }}>
        <Box sx={{ marginBottom: '16px' }}>
            <Skeleton variant="text" width={120} height={24} />
        </Box>
        <TableContainer sx={{ boxShadow: 'none' }}>
            <Table>
                <TableHead>
                    <TableRow>
                        {columns.map((col, i) => (
                            <TableCell key={i} sx={{ ...headerSx, width: col.width }}>
                                <Skeleton variant="text" width="60%" />
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[1, 2, 3].map((row) => (
                        <TableRow key={row}>
                            {columns.map((col, i) => (
                                <TableCell key={i} sx={cellSx}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {i === 0 && col.hasAvatar && (
                                            <Skeleton variant="circular" width={32} height={32} flexShrink={0} />
                                        )}
                                        <Skeleton variant="text" width="90%" height={20} />
                                    </Box>
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
);

const SearchSkeleton = ({ activeTab, hideChats }) => {
    return (
        <Box sx={{ mt: 2 }}>
            {!hideChats && (activeTab === 'all' || activeTab === 'chats') && (
                <TableSkeleton
                    columns={[
                        { width: '15%', hasAvatar: true },
                        { width: '35%' },
                        { width: '15%' },
                        { width: '25%' },
                        { width: '10%' }
                    ]}
                />
            )}
            {(activeTab === 'all' || activeTab === 'tickets') && (
                <TableSkeleton
                    columns={[
                        { width: '8%' },
                        { width: '32%' },
                        { width: '10%' },
                        { width: '15%' },
                        { width: '25%', hasAvatar: true },
                        { width: '10%' }
                    ]}
                />
            )}
            {(activeTab === 'all' || activeTab === 'knowledgeBase') && (
                <TableSkeleton
                    columns={[
                        { width: '40%' },
                        { width: '10%' },
                        { width: '15%' },
                        { width: '13%' },
                        { width: '12%' },
                        { width: '10%' }
                    ]}
                />
            )}
        </Box>
    );
};

export default SearchSkeleton;
